import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Description from 'pages/CreateEvent/Steps/Description/Description';
import Venue from 'pages/CreateEvent/Steps/Venue/Venue';
import Presenters from 'pages/CreateEvent/Steps/Presenters/Presenters';
import RunOfShow from 'pages/CreateEvent/Steps/RunOfShow/RunOfShow';
import Registration from 'pages/CreateEvent/Steps/Registration/Registration';
import Steps from 'pages/CreateEvent/Steps/Steps';
import { myHeaders_Auth_With_Cache_Control, org_friendly_url,events_list_api, user_access_token, user_Status_Ver, user_access_level, organization_user_access_level, user_entity_uuid, apiUrl} from 'Api/Api';
// , owner_perms,myHeaders_Authorized,myHeaders_Autorized
import axios from 'axios';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
//import { Redirect } from 'react-router-dom';
// import { origin } from 'utils/Helper';
import { local_routes } from 'utils/Routes';

class CreateEventTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event_info: {},
            source_info: {},
            //location_data: {},
            step_array: [],
            allow_presenters: false,
            step: 0,
            //descriptionTabData: null,
            //VenueTabData: null,
            //recDesData: null,
            //recVenData: null,
            loading:true,
            //locationData:null,
            //redirect:false,
            allowed:true,
            referrer: ''
        }
        //this.next = this.next.bind(this);
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
    }

    componentDidUpdate (prevProps) {
        //console.log("YO",prevProps);
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged () {
        console.log("PKCreateTabs routeChanged");
        this.setupPage();
        //this.setState({ step: 1});
        //this.forceUpdate();
        //this.APIPromises();
    }

    setupPage = async () => {
        let event_uuid = "";
        let otherpage = "";
        
        if (this.props.received_props.entity_uuid) {
            event_uuid = this.props.received_props.entity_uuid;
        }
        if (this.props.received_props.otherpage) {
            otherpage = this.props.received_props.otherpage;
        }
        
        let new_state = {...this.state};

        // make sure user is allowed
        if (!user_access_token || user_Status_Ver !== "1") {
            console.error("User not allowed to manage event");
            this.setState({ allowed: false });
            return;
        }
        /*
        let allowed = false;
        if (user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (organization_user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (!event_uuid) {
            // create - allow
            allowed = true;
        }
        
        if (!allowed) {
            // see if user is event organizer/owner
            let event_users_response = await axios.get(`${apiUrl}events/${event_uuid}/users`,myHeaders_Authorized);
            for (let user_obj of event_users_response.data) {
                if (user_obj.entity_uuid === user_entity_uuid) {
                    if (user_obj.xref_data) {
                        if (user_obj.xref_data.organizer_integer || user_obj.xref_data.entity_owner_integer) {
                            allowed = true;
                            break;
                        }
                    }
                }
            }
        }
        */
        
        /*
        console.log("CreateEventTabs allowed",allowed);
        if (!allowed) {
            console.error("User not allowed to manage event");
            this.setState({ allowed: false });
            return;
        }
        */
 
        console.log("CreateEventTabs props",this.props);
 
        new_state.allow_presenters = false;
 
        if (event_uuid) {
            // EDIT
            try {
                let params = {
                    attributes: ['zoom_webinar_object']
                }
                
                let api_promises = [
                    axios.get(`${events_list_api}/${event_uuid}`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${events_list_api}/${event_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control }),
                    axios.get(`${events_list_api}/${event_uuid}/venues`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${apiUrl}events/${event_uuid}/users?sort_obj=${encodeURIComponent('{"presenter_order_integer":"asc"}')}`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${events_list_api}/${event_uuid}/locations`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${events_list_api}/${event_uuid}/channels`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${events_list_api}/${event_uuid}/organizations`, myHeaders_Auth_With_Cache_Control)
                ];
                
                let source_entity_type = "";
                /*
                if (this.props.received_source_info.entity_type === 'locations') {
                    api_promises.push(axios.get(`${events_list_api}/${event_uuid}/locations`, myHeaders_Auth_With_Cache_Control));
                    source_entity_type = 'locations';
                } else if (this.props.received_source_info.entity_type === 'channels') {
                    api_promises.push(axios.get(`${events_list_api}/${event_uuid}/channels`, myHeaders_Auth_With_Cache_Control));
                    source_entity_type = 'channels';
                }
                */
                
                //if (user_access_level !== "admin" && organization_user_access_level !== "admin") {
                //    api_promises.push(axios.get(`${apiUrl}events/${event_uuid}/users`, myHeaders_Auth_With_Cache_Control));
                //}
                
                //let [event_data_response,source_data_response,event_users_response] = await Promise.all(api_promises);
                let [event_data_response,event_zoom_response,event_venues_response,event_users_response,event_locations_response,event_channels_response,event_organizations_response] = await Promise.all(api_promises);
                
                if (user_access_level !== "admin" && organization_user_access_level !== "admin") {
                    // not admin - must check ownership
                    let owner_match = false;
                    for (let event_user of event_users_response.data) {
                        if (event_user.entity_uuid === user_entity_uuid) {
                            if (event_user.xref_data && event_user.xref_data.entity_owner_integer && event_user.xref_data.entity_owner_integer >= 1) {
                                owner_match = true;
                                break;
                            }
                        }
                    }
                    if (!owner_match) {
                        this.setState({allowed:false});
                        return;
                    }
                }
                
                let event_data = event_data_response.data;
                event_data.editable = true;
                event_data.venues = event_venues_response.data;
                event_data.users = event_users_response.data;
                event_data.zoom_webinar_object = event_zoom_response.data.zoom_webinar_object || {};
                
                let source_data = {};
                if (event_locations_response.data.length > 0) {
                    source_data = event_locations_response.data[0];
                    source_data.entity_type = 'locations';
                } else if (event_channels_response.data.length > 0) {
                    source_data = event_channels_response.data[0];
                    source_data.entity_type = 'channels';
                } else if (event_organizations_response.data.length > 0) {
                    source_data = event_organizations_response.data[0];
                    source_data.entity_type = 'organizations';
                }
                if (this.props.received_source_info.referrer) {
                    source_data.referrer = this.props.received_source_info.referrer;
                }

                //source_data.entity_type = source_entity_type;

                if (event_data.venues.length > 0 || event_data.zoom_webinar_id) {
                    new_state.allow_presenters = true;
                }

                if (!event_data.event_presentation_format) {
                    event_data.event_presentation_format = '20x20';
                }
    
                // inform parent container about event/location info
                this.props.eventDataMet(event_data,source_data);
                
                new_state.event_info = event_data;
                new_state.source_info = source_data;
                
            } catch (err) {
                console.error("CreateEventTabs componentDidMount err",err);
                this.setState({allowed:false});
                return;
            }
            
            let presenters_link = "";
            if (new_state.allow_presenters) {
                presenters_link = this.workspace_base_url+local_routes.manageevent+'/'+event_uuid+'/presenters';
            }
            
            // populate steps with links
            new_state.step_array = [
                {
                    step_name: 'Description',
                    link: this.workspace_base_url+local_routes.manageevent+'/'+event_uuid+'/description'
                },
                {
                    step_name: 'Venue',
                    link: this.workspace_base_url+local_routes.manageevent+'/'+event_uuid+'/venue'
                },
                {
                    step_name: new_state.event_info.zoom_webinar_id ? <span>Presenters<span data-tip='Connected to Zoom' style={{ verticalAlign: "super", fontSize: "x-small", color: "#16a085" }}> ZOOM</span></span> : 'Presenters',
                    link: presenters_link
                },
            ];
            //if (user_access_level === 'admin') {
                if (new_state.event_info.zoom_webinar_id) {
                    new_state.step_array.push(
                        {
                            step_name: new_state.event_info.zoom_webinar_id ? <span>Registration<span data-tip='Connected to Zoom' style={{ verticalAlign: "super", fontSize: "x-small", color: "#16a085" }}> ZOOM</span></span> : 'Registration',
                            link: this.workspace_base_url+local_routes.manageevent+'/'+event_uuid+'/registration'
                        }
                    );
                }
                if (user_access_level === 'admin' || new_state.event_info.zoom_webinar_id) {
                    new_state.step_array.push(
                        {
                            step_name: 'Run Of Show',
                            link: this.workspace_base_url+local_routes.manageevent+'/'+event_uuid+'/runofshow'
                        }
                    );
                }
            //}
            
            
            /*
            let event_data = await axios.get(`${events_list_api}/${event_uuid}`, myHeaders_Authorized);
            let user_location_data = await axios.get(`${events_list_api}/${event_uuid}/locations`, myHeaders_Authorized);
            if (user_location_data.data && user_location_data.data[0]) {
                this.props.locationDataMet(user_location_data.data[0],false,event_data.data.entity_name)
            }
            */
            //this.setState({ loading: false })
        } else {
            // CREATE
            let source_entity_type = "";
            let api_promises = [];
            
            // where did we come from?
            if (this.props.received_source_info.entity_type === 'locations') {
                api_promises.push(axios.get(`${apiUrl}locations/${this.props.received_source_info.entity_uuid}`, myHeaders_Auth_With_Cache_Control));
                source_entity_type = 'locations';
            } else if (this.props.received_source_info.entity_type === 'channels') {
                api_promises.push(axios.get(`${apiUrl}channels/${this.props.received_source_info.entity_uuid}`, myHeaders_Auth_With_Cache_Control));
                source_entity_type = 'channels';
            } else if (this.props.received_source_info.entity_type === 'organizations') {
                api_promises.push(axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_Auth_With_Cache_Control));
                source_entity_type = 'organizations';
            } else {
                // unknown source/referrer! redirect to myevents
                console.error("Unknown source/referrer! Redirect to myevents");
                this.props.history.push(this.workspace_base_url+local_routes.myevents);
                return;
            }
            
            let [event_source_response] = await Promise.all(api_promises);

            let source_data = event_source_response.data;
            if (this.props.received_source_info.referrer) {
                source_data.referrer = this.props.received_source_info.referrer;
            }

            source_data.entity_type = source_entity_type;

            // inform parent container about event/location info
            this.props.eventDataMet({},source_data);
                
            new_state.event_info = {};    
            new_state.source_info = source_data;           
            
            new_state.step_array = [
                {
                    step_name: 'Description'
                },
                {
                    step_name: 'Venue'
                },
                {
                    step_name: 'Presenters'
                },
            ];
            if (user_access_level === 'admin') {
                new_state.step_array.push(
                    {
                        step_name: 'Run Of Show',
                    }
                );
            }

        }
        
        //console.log("HI",presentation_uuid,otherpage,this.props);
        
        if (otherpage === "description") {
            new_state.step = 1;
        } else if (otherpage === "venue") {
            new_state.step = 2;
        } else if (otherpage === "presenters") {
            if (new_state.allow_presenters) {
                new_state.step = 3;
            } else {
                new_state.step = 2;
            }
        } else if (otherpage === "registration") {
            new_state.step = 4;
        } else if (otherpage === "runofshow") {
            new_state.step = 5;
        } else {
            // no otherpage or otherpage not recognized - go to description tab
            new_state.step = 1;
        }
        
        //new_state.presentation_uuid = presentation_uuid;
        new_state.loading = false;
        console.log("CreateEventTabs new_state",new_state);
        this.setState(new_state);
    }   

    componentDidMount = async function () {
        this.setupPage();
    }  

    /*
    componentDidMount = async function () {
        const { match: { params: { event_uuid } = {} } = {} } = this.props;
        let { match } = this.props;
        
        // make sure user is allowed
        if (!user_access_token || user_Status_Ver !== "1") {
            console.error("User not allowed to manage event");
            this.setState({ allowed: false });
            return;
        }
        let allowed = false;
        if (user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (organization_user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (!event_uuid) {
            // create - allow
            allowed = true;
        }
        if (!allowed) {
            // see if user is event organizer/owner
            let event_users_response = await axios.get(`${apiUrl}events/${event_uuid}/users`,myHeaders_Authorized);
            for (let user_obj of event_users_response.data) {
                if (user_obj.entity_uuid === user_entity_uuid) {
                    if (user_obj.xref_data) {
                        if (user_obj.xref_data.organizer_integer || user_obj.xref_data.entity_owner_integer) {
                            allowed = true;
                            break;
                        }
                    }
                }
            }
        }
        console.log("CreateEventTabs allowed",allowed);
        if (!allowed) {
            console.error("User not allowed to manage event");
            this.setState({ allowed: false });
            return;
        }
        
        
        // Data coming from event list page
        if (this.props && this.props.location && this.props.location.data) {
            this.setState({ locationData: this.props.location.data, loading: false })
            this.props.locationDataMet(this.props.location.data,true,null)
        } else {
            if (event_uuid) {
                // Data getting based event id received from URL
                let event_data = await axios.get(`${events_list_api}/${event_uuid}`, myHeaders_Authorized);
                let user_location_data = await axios.get(`${events_list_api}/${event_uuid}/locations`, myHeaders_Authorized);
                if (user_location_data.data && user_location_data.data[0]) {
                    this.props.locationDataMet(user_location_data.data[0],false,event_data.data.entity_name)
                }
                this.setState({ loading: false })
            }
        } 

        
        // Checking whether users origin is valid or not. if not redirect to home.
        if(( this.props.location.data === undefined && event_uuid=== undefined ) || (event_uuid && match.params.otherpage === undefined ))
        {
            this.setState({redirect:true})
        }
        // Checking URL which tab user want to edit 
        if(match && match.params.otherpage==="description")
        {
            this.setState({step:1})
        }
        else if(match && match.params.otherpage==="venues")
        {
            
            this.setState({step:2})
        }
        else if(match && match.params.otherpage==="presenters")
        {
            this.setState({step:3})
        }
        else {
            this.setState({step:1})
        }
    }
    */

    next = () => {
        console.log("NEXT",this.state.step);
    }

    prev = () => {
        console.log("PREV",this.state.step);
    }

    /*
    // For storing created/edited ID fro next tabsin description tab
    onGetDescriptionTab = (data) => {
        var self = this;
        self.setState({ descriptionTabData: data })
    }

    // For storing created/edited data fro next tabs Venues tab
    onGetVenueData = (data) => {
        var self = this;
        self.setState({ VenueTabData: data })
    }

    // to get old data when user clicks on prev tab of description tab
    getRecDesData = (desData) => {
        var self = this;
        self.setState({ recDesData: desData })
    }

    // to get old data when user clicks on prev tab of venues tab
    getRecVenData = (venData) => {
        var self = this;
        self.setState({ recVenData: venData })
    }

    // to get back to old events list 
    resetToList = () => {
        this.props.resetToList();
    }

    next() {
        this.setState({
            step: this.state.step + 1,
        })
    }

    prev() {
        this.setState({ step: this.state.step - 1, ImageUploadLoader: false, descriptionLoader: false });
    }

    handleOnChange(e) {
        this.setState({ [e.target.id]: e.target.value })
    }

    handleOnCheck(e) {
        this.setState({ [e.target.id]: !this.state.terms })
    }
    */
    
    render() {
        //const { descriptionTabData, VenueTabData, recDesData, recVenData,locationData,redirect } = this.state;
        if (!this.state.allowed) {
            return (
                <EmptyMessage empty_message="Not allowed to edit this Event" />
            );
        }
        /*
        if (!this.state.allowed) {
            return (
                <div className="empty-msg">
                    <EmptyMessage empty_message="Not allowed to edit this event" />
                </div>
            );
        }
        */
        
        /*
        if (redirect) {
            return <Redirect  
            //onClick={window.location.href=`${origin}`}
            //to={window.location.href=`${origin}`}
            to={`${this.workspace_base_url}/`}
             />;
        }  
        else if (this.state.loading === true) 
        {
            return (
              <ActivityIndicator theme="spinner" />
            )
          }
          else {
        */
        if (this.state.loading === true) {
            return (
              <ActivityIndicator theme="spinner" />
            )
         }
        
        switch (this.state.step) {
            case 1:
                return <div>
                    <Steps step_array={this.state.step_array} step={this.state.step} />
                    <Description
                        event_info={this.state.event_info}
                        source_info={this.state.source_info}
                        event_uuid={this.props.received_props.entity_uuid}
                        next={() => this.next()}
                        //{...this.props}
                        //onChange={this.handleOnChange.bind(this)}
                        //getDescriptionData={this.onGetDescriptionTab}
                        //getRecDesData={this.getRecDesData}
                        //recDesData={recDesData}
                        //next={this.next.bind(this)}
                        //locationData={locationData}
                        // resetToList={this.props.resetToList.bind(this)} 
                        />
                </div>
            case 2:
                return <div>
                    <Steps step_array={this.state.step_array} step={this.state.step} />
                    <Venue
                        event_info={this.state.event_info}
                        source_info={this.state.source_info}
                        event_uuid={this.props.received_props.entity_uuid}
                        next={() => this.next()}
                        prev={() => this.prev()}
                        //{...this.props}
                        //onChange={this.handleOnChange.bind(this)}
                        //next={this.next.bind(this)}
                        //prev={this.prev.bind(this)}
                        //getRecVenData={this.getRecVenData}
                        //recVenData={recVenData}
                        //getVenueData={this.onGetVenueData}
                        //descriptionData={descriptionTabData}
                        //locationData={locationData}
                        // resetToList={this.props.resetToList.bind(this)} 
                        />
                </div>
            case 3:
                return <div>
                    <Steps step_array={this.state.step_array} step={this.state.step} />
                    <Presenters
                        event_info={this.state.event_info}
                        source_info={this.state.source_info}
                        event_uuid={this.props.received_props.entity_uuid}
                        next={() => this.next()}
                        prev={() => this.prev()}
                        //{...this.props}
                        //onChange={this.handleOnChange.bind(this)}
                        //next={this.next.bind(this)}
                        //prev={this.prev.bind(this)}
                        //descriptionData={descriptionTabData}
                        //VenueTabData={VenueTabData}
                        //locationData={locationData}
                        // resetToList={this.props.resetToList.bind(this)}
                         />
                </div>
            case 4:
                return <div>
                    <Steps step_array={this.state.step_array} step={this.state.step} />
                    <Registration
                        event_info={this.state.event_info}
                        source_info={this.state.source_info}
                        event_uuid={this.props.received_props.entity_uuid}
                        next={() => this.next()}
                        prev={() => this.prev()}
                    />
                </div>
            case 5:
                return <div>
                    <Steps step_array={this.state.step_array} step={this.state.step} />
                    <RunOfShow
                        event_info={this.state.event_info}
                        source_info={this.state.source_info}
                        event_uuid={this.props.received_props.entity_uuid}
                        next={() => this.next()}
                        prev={() => this.prev()}
                    />
                </div>
            default:
                return null
        }
    }
}

export default withRouter(CreateEventTabs);